import { t } from 'i18next';
import {
  ICategory,
  ISubcategory,
} from 'redux/modules/Categories/categoriesTypes';

export const translateSubCategory = (
  subCategory: string,
  categoryTitle: string,
  language: string,
) => {
  return language === 'en'
    ? subCategory
    : t(`subCategories.${categoryTitle}.${subCategory}`, {
        defaultValue: subCategory,
      });
};

export const handleSubcategoryOptionLabel = (
  opt: ISubcategory,
  categories: ICategory[],
  language: string,
) => {
  const subcategory = opt as ISubcategory;
  const categoryTitle = categories?.find(
    (cat) => cat?.id === subcategory.categoryId,
  )?.title;
  return translateSubCategory(subcategory.title, categoryTitle ?? '', language);
};
